<template>
  <div class="wrapper">
    <div class="tw-container tw-mx-auto lg:tw-w-1/3 tw-mb-12">
      <div class="tw-overflow-hidden tw-rounded-lg tw-shadow-lg tw-bg-white tw-block tw-cursor-pointer tw-group tw-w-full tw-block tw-px-12 tw-py-12">
          
        <h2 class="tw-text-5xl tw-font-black tw-mb-12">Log In</h2>

        <LoginForm />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, onMounted, ref, watch
  } from 'vue';
  import { useRoute } from 'vue-router';

  import { storeToRefs } from 'pinia'

  // Data
  import { useBasketStore } from '../../stores/basket';
  import { useUserStore } from '../../stores/user';
  import { useFlashMessageStore } from "../../stores/flashMessages";
  import type User from '../../classes/User';
  import type FlashMessage from '../../types/FlashMessage';
  import type ApiError from '../../types/ApiError'

  import { plainToClass } from 'class-transformer';
  import LoginForm from './_LoginForm.vue';

  const basketStore = useBasketStore();
  const userStore = useUserStore();
  const flashMessageStore = useFlashMessageStore();
  
  const route = useRoute();

  const email = ref('');
  const password = ref('');
  const submittingLogin = ref(false);

  const { user } = storeToRefs(userStore);
  const prevUser = null as (User | null)

  watch(user, () => {
    const updatedVal = userStore.user
   
    if (updatedVal != prevUser) {
      submittingLogin.value = false
      // router.push()
    }
  })

  const submitLogin = ((event: Event) => {
    let basket_id = "";

    if (basketStore.basket != null && basketStore.basket.id != null) {
      basket_id = basketStore.basket.id
    }
    submittingLogin.value = true
    
    userStore.login(email.value, password.value, basket_id).catch((error: ApiError) => {
      submittingLogin.value = false
    });
  })

  onMounted(() => {
    if (userStore.user) {
      const message = {
          id: Math.round(Date.now() / 1000),
          messageType: "success",
          text: "You are already logged in",
          headline: "",
          delay: 5000, // ms
          icon: "",
          cssClass: "",
      } as FlashMessage;
      flashMessageStore.addMessage(message);
    }
  })

</script>